import * as React from "react";
import asCard, { CardProps } from "./Card";

export interface ImageCardProps extends CardProps {
    imageURL: string;
}

export class ImageCard extends React.Component<ImageCardProps> {
    render() {
        if (this.props.height) {
            console.log("in");
            return (
                <img
                    src={this.props.imageURL}
                    style={{ height: this.props.height * 0.9, width: this.props.width * 0.9, objectFit: "contain" }}
                />
            );
        } else {
            return (
                <img
                    src={this.props.imageURL}
                    style={{
                        opacity: 0,
                        height: this.props.maxHeight * 0.8,
                        width: this.props.width * 0.9,
                        objectFit: "contain",
                    }}
                    alt=""
                />
            );
        }
    }
}

export default asCard(ImageCard);
